import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    host: '',
    enable: {
        tracking: false,
        countrySelector: false,
    },
    tracking: {
        tagmanager: {
            tagCode: 'GTM-WP4N',
        },
    },
    languages: [],
    isPrive: false,
});
